import gql from "graphql-tag";

export const SCHEDULE_MESSAGE_FRAGMENT = gql`
fragment ScheduleMessageFragment on ScheduleMessage {
  id
  externalChatChannelId
  message
  sendAt
  tagsFilter
  tagsFilterAny
  tagsFilterNone
  funnelStepIdFilter
  processedAt
  templateId
  templateParams
  phoneNumbers
  sendToIndividualContacts
  sendToFilteredContacts
  intervalSeconds
  status
  scheduledCount
  successCount
  errorCount
  cancelledAt
  forcedAt
  sendAtRecurring {
    dayOfWeek
    dayOfMonth
    time
  }
  parentRecurringScheduleMessageId
  recurringConfigId

  firingLimit
  firingInterval
  clientIds

  tagToAdd
  funnelStepToAdd

  parentBulkScheduleMessageId
}
`;

export const EXTERNAL_CHAT_CHANNEL_FRAGMENT = gql`
  fragment ExternalChatChannelFragment on ExternalChatChannel {
    id
    authenticationError
    authenticationidInChannel
    botEnabled
    botReactivationTimeSeconds
    chatsSyncLimit
    disableBotAfterFirstAnswer
    disableGroups
    disabled
    enableWhatsappSessionSave
    idInChannel
    shouldSendUserName
    markAsReadAfterReply
    isChatWidget
    isInternalUserChat
    isMobileBatteryPlugged
    isServerRestarting
    localServerHeartbeatDate
    messagesSyncLimit
    mobileBatteryPercent
    name
    qrCode
    shouldRestartServer
    shouldResyncMessages
    shouldResyncMessagesFromClientIds
    state
    statusDescription
    statusInChannel
    syncStatus
    syncProgressCurrent
    syncProgressMax
    lastSyncDate
    type
    instanceType
    whatsappWebJsVersion

    # task info
    # ecsTaskArns
    # ecsTaskArnsLogLinks
    ecsTaskHistory {
      startDate
      ecsTaskArn
      ecsTaskInfo
    }
    serverVersion

    key
    token
    
    scheduleMessages {
      ...ScheduleMessageFragment
    }

    username
    password
  }
  ${SCHEDULE_MESSAGE_FRAGMENT}
`;

export const EXTERNAL_CHAT_CHANNEL_ACTION_FRAGMENT = gql`
  fragment ExternalChatChannelActionFragment on ExternalChatChannelAction {
    _id
    date
    externalChatChannelId
    # who did the action
    from
    fromId
    # status is true when typing, false when not
    status
    # who received the action
    to
    toId
    type
  }
`;

export const EXTERNAL_CHAT_MESSAGE_FRAGMENT = gql`
  fragment ExternalChatMessageFragment on ExternalChatMessage {
    _id
    _idInChannel
    clientId
    contacts {
      addresses {
        fullAddress
        type
      }
      emails {
        email
        type
      }
      name
      phones {
        phone
        type
      }
    }
    content
    createdAt
    createdAtInChannel
    date
    direction
    errorMessage
    externalChatChannelId
    forwarded
    forwardedManyTimes
    from
    fromBot
    fromId
    fromIdInChannel
    groupId
    groupIdInChannel
    hasError
    hasMedia
    location {
      description
      lat
      lon
    }
    list {
      title
      description
      buttonText
      footerText
      sections {
        title
        rows {
          id
          title
          description
        }
      }
    }
    media {
      fileName
      fileNameOrig
      mimetype
      size
      url
      urlValidUntil
    }
    quotedMessage {
      _id
      content
      direction
      from
      fromId
      to
      toId
      type
      list {
        title
        description
      }
    }
    quotedMessageId
    markedForDeletionAt
    markedForDeletionUserId
    mediaDownloadPending
    processedAt
    readBy {
      date
      peer
      peerId
    }
    receivedBy {
      date
      peer
      peerId
    }
    replyOptions
    scheduleMessageId
    sendSchedule
    sentAt
    templateId
    templateParams
    to
    toId
    toIdInChannel
    type
    updatedAt
    editedAt
    revokedAt
    lastClientMessageDate
  }
`;

export const GUPSHUP_DAILY_USAGE_FRAGMENT = gql`
  fragment GupshupDailyUsageFragment on GupshupDailyUsage {
    appId
    appName
    authentication
    cumulativeBill
    currency
    date
    discount
    fep
    ftc
    gsCap
    gsFeeCapiMarketing
    gsFees
    incomingMsg
    internationalAuthentication
    marketing
    mmLiteBid
    mmLiteMarketing
    outgoingMediaMsg
    outgoingMsg
    service
    templateMediaMsg
    templateMsg
    totalFees
    totalMsg
    utility
    voiceInMetaFeeUsage
    voiceOutMetaFeeUsage
    waFees
  }
`;
